import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {Chart} from 'chart.js';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Router} from '@angular/router';

@Component({
    selector: 'app-bar-chart-stable-unstable-therapy-uc',
    templateUrl: './bar-chart-stable-unstable-therapy-uc.component.html',
    styleUrls: ['./bar-chart-stable-unstable-therapy-uc.component.css']
})

export class BarChartStableUnstableTherapyUCComponent implements OnInit, OnDestroy {
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  subscription: Subscription;
  subscription1: Subscription;
  // ******************************************************************************************************************
  // bar chart dei pazienti globali malati in miglioramento, in peggioramento, stabili, per genere
  // ******************************************************************************************************************
  // bar chart arrays
  remissione = [];
  recidiva = [];
  // 5ASAOS, TOPICA, GSCOS, IMM, BIO
  // other arrays
  stabiliRecidiva5ASAOS = 0;
  stabiliRemissione5ASAOS = 0;
  instabiliMiglRecidiva5ASAOS = 0;
  instabiliPegRecidiva5ASAOS = 0;
  instabiliMiglRemissione5ASAOS = 0;
  instabiliPegRemissione5ASAOS = 0;
  
  stabiliRecidivaTOPICA = 0;
  stabiliRemissioneTOPICA = 0;
  instabiliMiglRecidivaTOPICA = 0;
  instabiliPegRecidivaTOPICA = 0;
  instabiliMiglRemissioneTOPICA = 0;
  instabiliPegRemissioneTOPICA = 0;
  
  stabiliRecidivaGCSOS = 0;
  stabiliRemissioneGCSOS = 0;
  instabiliMiglRecidivaGCSOS = 0;
  instabiliPegRecidivaGCSOS = 0;
  instabiliMiglRemissioneGCSOS = 0;
  instabiliPegRemissioneGCSOS = 0;

  stabiliRecidivaBIO = 0;
  stabiliRemissioneBIO = 0;
  instabiliMiglRecidivaBIO = 0;
  instabiliPegRecidivaBIO = 0;
  instabiliMiglRemissioneBIO = 0;
  instabiliPegRemissioneBIO = 0;

  stabiliRecidivaIMM = 0;
  stabiliRemissioneIMM = 0;
  instabiliMiglRecidivaIMM = 0;
  instabiliPegRecidivaIMM = 0;
  instabiliMiglRemissioneIMM = 0;
  instabiliPegRemissioneIMM = 0;
  // elements for chart
  canvas: any;
  ctx: any;
  myChartStableUnstableUCTherapy: Chart;
  // ******************************************************************************************************************
  // bar chart
  // ******************************************************************************************************************
  public barChartLabelsGlobal = ['5-ASA-OS-STABILI','5-ASA-OS-IN MIGLIORAMENTO','5-ASA-OS-IN PEGGIORAMENTO',
  'TOPICA-STABILI','TOPICA-IN MIGLIORAMENTO','TOPICA-IN PEGGIORAMENTO',
  'GCS-OS-STABILI','GCS-OS-IN MIGLIORAMENTO','GCS-OS-IN PEGGIORAMENTO',
  'BIO.-STABILI','BIO.-IN MIGLIORAMENTO','BIO.-IN PEGGIORAMENTO',
  'IMM.-STABILI','IMM.-IN MIGLIORAMENTO','IMM.-IN PEGGIORAMENTO'];
  public barChartTypeGlobal = 'horizontalBar';
  public barChartLegendGlobal = true;
  public barChartDataGlobal = [
    {
      data: this.recidiva,
      barThickness: 10,
      backgroundColor: ['#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', 
      '#ff5232','#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232'],
      hoverBackgroundColor: ['#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507','#d11507', '#d11507',
      '#d11507','#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507'],
      label: 'RECIDIVA',
      datalabels: {
        color: 'white', // Color for percentage value
      }
    },
    {
      data: this.remissione,
      barThickness: 10,  // number (pixels) or 'flex'
      backgroundColor: ['#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e',
      '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e'],
      hoverBackgroundColor: ['#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c',
      '#03c03c','#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c'],
      label: 'REMISSIONE',
      datalabels: {
        color: 'white' // Color for percentage value}
      }
    }
    ];
  // table
  dataSource = new MatTableDataSource();
  headElements = ['name', 'surname', 'card', 'questionnaire', 'email', 'chat'];
  totalSize = 0;
  // TABELLE DISPONIBILI
  isHovered = false;
  // paginator della tabella
  public pageSize = 5;
  public currentPage = 0;
  public tasks: any[];
  @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
      paginator._intl.previousPageLabel = 'Pagina precedente';
      paginator._intl.nextPageLabel = 'Pagina successiva';
    }
  }

  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private router: Router) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  ngOnInit(): void {
    this.subscription1 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrieveTherapyStableAndUnstable();
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscription1.unsubscribe();
  }

  retrieveTherapyStableAndUnstable(){
    this.subscription = this.doctorService.getUCStableAndUnstableTherapy().subscribe( data => {
      let keys = Object.keys(data);
      console.log("Data therapy: " + data);
      let values = Object.values(data);
      for (let i in keys){
        var key = keys[i];
        //console.log("Key..." + key);
        if (key === 'StabiliRemissioneTherapy5ASAOS'){
          this.stabiliRemissione5ASAOS = values[i];
        }
        else if (key === 'StabiliRecidivaTherapy5ASAOS'){
          this.stabiliRecidiva5ASAOS = values[i];
        }
        else if (key === 'InstabiliMiglRecidivaTherapy5ASAOS'){
          this.instabiliMiglRecidiva5ASAOS = values[i];
        }
        else if (key === 'InstabiliPegRecidivaTherapy5ASAOS'){
          this.instabiliPegRecidiva5ASAOS = values[i];
        }
        else if (key === 'InstabiliMiglRemissioneTherapy5ASAOS'){
          this.instabiliMiglRemissione5ASAOS = values[i];
        }
        else if (key === 'InstabiliPegRemissioneTherapy5ASAOS'){
          this.instabiliPegRemissione5ASAOS = values[i];
        }
        else if (key === 'StabiliRemissioneTherapyTOPICA'){
          this.stabiliRemissioneTOPICA = values[i];
        }
        else if (key === 'StabiliRecidivaTherapyTOPICA'){
          this.stabiliRecidivaTOPICA = values[i];
        }
        else if (key === 'InstabiliMiglRecidivaTherapyTOPICA'){
          this.instabiliMiglRecidivaTOPICA = values[i];
        }
        else if (key === 'InstabiliPegRecidivaTherapyTOPICA'){
          this.instabiliPegRecidivaTOPICA = values[i];
        }
        else if (key === 'InstabiliMiglRemissioneTherapyTOPICA'){
          this.instabiliMiglRemissioneTOPICA = values[i];
        }
        else if (key === 'InstabiliPegRemissioneTherapyTOPICA'){
          this.instabiliPegRemissioneTOPICA = values[i];
        }
        else if (key === 'StabiliRemissioneTherapyGCSOS'){
          this.stabiliRemissioneGCSOS = values[i];
        }
        else if (key === 'StabiliRecidivaTherapyGCSOS'){
          this.stabiliRecidivaGCSOS = values[i];
        }
        else if (key === 'InstabiliMiglRecidivaTherapyGCSOS'){
          this.instabiliMiglRecidivaGCSOS = values[i];
        }
        else if (key === 'InstabiliPegRecidivaTherapyGCSOS'){
          this.instabiliPegRecidivaGCSOS = values[i];
        }
        else if (key === 'InstabiliMiglRemissioneTherapyGCSOS'){
          this.instabiliMiglRemissioneGCSOS = values[i];
        }
        else if (key === 'InstabiliPegRemissioneTherapyGCSOS'){
          this.instabiliPegRemissioneGCSOS = values[i];
        }
        else if (key === 'StabiliRemissioneTherapyBIO'){
          this.stabiliRemissioneBIO = values[i];
        }
        else if (key === 'StabiliRecidivaTherapyBIO'){
          this.stabiliRecidivaBIO = values[i];
        }
        else if (key === 'InstabiliMiglRecidivaTherapyBIO'){
          this.instabiliMiglRecidivaBIO = values[i];
        }
        else if (key === 'InstabiliPegRecidivaTherapyBIO'){
          this.instabiliPegRecidivaBIO = values[i];
        }
        else if (key === 'InstabiliMiglRemissioneTherapyBIO'){
          this.instabiliMiglRemissioneBIO = values[i];
        }
        else if (key === 'InstabiliPegRemissioneTherapyBIO'){
          this.instabiliPegRemissioneBIO = values[i];
        }
        if (key === 'StabiliRemissioneTherapyIMM'){
          this.stabiliRemissioneIMM = values[i];
        }
        else if (key === 'StabiliRecidivaTherapyIMM'){
          this.stabiliRecidivaIMM = values[i];
        }
        else if (key === 'InstabiliMiglRecidivaTherapyIMM'){
          this.instabiliMiglRecidivaIMM = values[i];
        }
        else if (key === 'InstabiliPegRecidivaTherapyIMM'){
          this.instabiliPegRecidivaIMM = values[i];
        }
        else if (key === 'InstabiliMiglRemissioneTherapyIMM'){
          this.instabiliMiglRemissioneIMM = values[i];
        }
        else if (key === 'InstabiliPegRemissioneTherapyIMM'){
          this.instabiliPegRemissioneIMM = values[i];
        }
      }
      
      // riempio il vettore della categoria 'recidiva' in ordine stabili, miglioramento e peggioramento
      this.recidiva.push(this.stabiliRecidiva5ASAOS);
      this.recidiva.push(this.instabiliMiglRecidiva5ASAOS);
      this.recidiva.push(this.instabiliPegRecidiva5ASAOS);
      this.recidiva.push(this.stabiliRecidivaTOPICA);
      this.recidiva.push(this.instabiliMiglRecidivaTOPICA);
      this.recidiva.push(this.instabiliPegRecidivaTOPICA);
      this.recidiva.push(this.stabiliRecidivaGCSOS);
      this.recidiva.push(this.instabiliMiglRecidivaGCSOS);
      this.recidiva.push(this.instabiliPegRecidivaGCSOS);
      this.recidiva.push(this.stabiliRecidivaBIO);
      this.recidiva.push(this.instabiliMiglRecidivaBIO);
      this.recidiva.push(this.instabiliPegRecidivaBIO);
      this.recidiva.push(this.stabiliRecidivaIMM);
      this.recidiva.push(this.instabiliMiglRecidivaIMM);
      this.recidiva.push(this.instabiliPegRecidivaIMM);
      console.log("Recidiva: " + this.recidiva);
      // riempio il vettore della categoria 'remissione' in ordine, stabili, miglioramento e peggioramento
      this.remissione.push(this.stabiliRemissione5ASAOS);
      this.remissione.push(this.instabiliMiglRemissione5ASAOS);
      this.remissione.push(this.instabiliPegRemissione5ASAOS);
      this.remissione.push(this.stabiliRemissioneTOPICA);
      this.remissione.push(this.instabiliMiglRemissioneTOPICA);
      this.remissione.push(this.instabiliPegRemissioneTOPICA);
      this.remissione.push(this.stabiliRemissioneGCSOS);
      this.remissione.push(this.instabiliMiglRemissioneGCSOS);
      this.remissione.push(this.instabiliPegRemissioneGCSOS);
      this.remissione.push(this.stabiliRemissioneBIO);
      this.remissione.push(this.instabiliMiglRemissioneBIO);
      this.remissione.push(this.instabiliPegRemissioneBIO);
      this.remissione.push(this.stabiliRemissioneIMM);
      this.remissione.push(this.instabiliMiglRemissioneIMM);
      this.remissione.push(this.instabiliPegRemissioneIMM);
      console.log("Remissione: " + this.remissione);
      this.canvasSetting();
    }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }

  canvasSetting() {
    this.canvas = document.getElementById('myChartStableUnstableUCTherapy') as HTMLCanvasElement;
    this.ctx = this.canvas.getContext('2d');
    this.myChartStableUnstableUCTherapy = new Chart(this.ctx, {
      type: this.barChartTypeGlobal,
      data: {
        labels: this.barChartLabelsGlobal,
        datasets: this.barChartDataGlobal,
      },
      options: {
        maintainAspectRatio: true,
        responsive: true,
        onHover: (event) => {
          if (this.myChartStableUnstableUCTherapy.getElementAtEvent(event).length > 0) {
            if (this.myChartStableUnstableUCTherapy.getElementAtEvent(event)[0]['_model'].datasetLabel === 'RECIDIVA' ||
              this.myChartStableUnstableUCTherapy.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE') {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          }
        },
        scales: {
          xAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
          yAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
        },
        legend: {
          onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
            if (legendItem.text.length > 0 && (legendItem.text === 'RECIDIVA' || legendItem.text === 'REMISSIONE')) {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          },
          display: true,
          position: 'top',
          align: 'center',
          labels: {
            usePointStyle: true,
            fontColor: '#006192',
            fontSize: 18,
            fontFamily: 'Helvetica',
          }
        },
        tooltips: {
          // content: '{pathology}: {number}',
          backgroundColor: '#1c1c1c',
          bodyFontSize: 18,
          titleFontSize: 18,
          cornerRadius: 5,
          caretPadding: 10
        },
        title: {
          display: true,
          text: 'Numero di pazienti',
          fontColor: '#006192',
          fontSize: 20,
          fontFamily: 'Helvetica',
        },
        hover: {
          mode: 'nearest',
          intersect: true
        }
      }
    });
    }

    // pagination della tabella di stabili recidiva patients
  // paginazione effettuata manualmente
  getPagination(data) {
    console.log(data);
    this.dataSource = new MatTableDataSource<Patient>();
    // this.dataSource.data = data;
    this.tasks = data;
    this.currentPage = 0; // così che appena si seleziona il grafico appaia la giusta pagina con le prime persone
    this.totalSize = this.tasks.length;
    this.iterator(); // iterator sistema i nomi alla pagina corretta
  }
  handlePage(event?: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.iterator();
  }
  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    this.dataSource.data = this.tasks.slice(start, end);
  }
  // set hovered variable
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable
  unsetHoverVariable(): void {
    this.isHovered = false;
  }
  openPanel(patient) {
    this.router.navigateByUrl('/patient-panel/' + patient.ssn + '/general-status');
  }
  openQuestionnaire(patient) {
    this.router.navigateByUrl('/patient-questionnaires-show/' + patient.ssn + '/patient-sccai' + '/general-status');
  }
  openChat(patient) {
    this.router.navigateByUrl('/doctor-chat/' + patient.ssn + '/general-status');
  }
  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log('fired'));
  }

}